module.exports = __webpack_public_path__ + "img/slide_next.ea39141e.svg";